var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.sendFile}}),_c('editor',{ref:"editor",attrs:{"init":_vm.initType,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }